import axios from '@/axios';

export default {
    verifyDo(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('sales-and-purchase/project-warranty/list-delivery-order',payload 
            // { 
            //     params: {
            //         id: idOrSo
            //     }
            // }
            ).then((response) => {
                // console.log('list DO',response.data.data)
                resolve(response.data.data);
            }).catch((e) => {
                console.log(e);
                reject(e);
            })
        });
    },
    getProjectsWarranty({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.get('sales-and-purchase/project-warranty', {params:params}).then((response) => {
                // console.log('response semua project',response.data.data)
                commit('SET_PROJECTS', response.data.data);
                resolve(response.data);
            }).catch((e) => {
                console.log(e);
            })
        });
    },
    saveProject(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('sales-and-purchase/project-warranty', payload).then((response) => {
                resolve(response.data.data);
            }).catch((e) => {
                console.log(e);
                reject(e);
            });
        });
    },
    searchSO(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('sales-and-purchase/project-warranty/search-sale-order', payload)
            .then((response) => {
                resolve(response.data.data);
            }).catch((e) => {
                console.log(e);
                reject(e)
            })
        });
    },
    deleteProject(context, id) {
        return new Promise((resolve, reject) => {
            axios.delete(`sales-and-purchase/project-warranty/${id}`).then((response) => {
                resolve(response.data.data);
            }).catch((e) => {
                console.log(e);
                reject(e)
            })
        });
    },
    listSalesOrder(context, query) {
        return new Promise((resolve, reject) => {
            axios.get('sales-and-purchase/project-warranty/list-sale-order').then((response) => {
                resolve(response.data.data);
            }).catch((e) => {
                console.log(e)
                reject(e)
            })
        });
    },
    getProject(context, id) {
        return new Promise((resolve, reject) => {
            axios.get(`sales-and-purchase/project-warranty/${id}`).then((response) => {
                // console.log('respond store',response.data.data )
                resolve(response.data.data);
            }).catch((e) => {
                console.log(e)
                reject(e)
            })
        });
    },
    updateProject(context, payload) {
        let { _id } = payload;
        return new Promise((resolve, reject) => {
            axios.put(`sales-and-purchase/project-warranty/${_id}`, payload).then((response) => {
                resolve(response.data.data);
            }).catch((e) => {
                console.log(e)
                reject(e)
            })
        });
    }
}